import { render, staticRenderFns } from "./OsobaRazdobljeBase.vue?vue&type=template&id=12afcd79&scoped=true&"
import script from "./OsobaRazdobljeBase.vue?vue&type=script&lang=js&"
export * from "./OsobaRazdobljeBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12afcd79",
  null
  
)

export default component.exports